export default class UserStatus {
  isAdmin: boolean; // read-only

  constructor() {
    this.isAdmin = false;
  }
}
